export * from './IconHandWaveGradient';
export { default as IconHandWaveGradient } from './IconHandWaveGradient';
